import React from 'react';

import ProductDetailPanel from '../../ProductDetailPanel';
import Anchor from '../../../../../components/link/Anchor';
import CountOfTotal from '../../../../../components/CountOfTotal';
import ImgUploadForm from '../../../../../components/form/ImgUploadForm';
import InputForm from '../../../../../components/form/InputForm';
import { compareProductVersion } from '../../../../../lib/utils';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  MAXIMUM_NUMBER_OF_ORDER_EXAMPLE_MESSAGE,
  MAXIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG,
  MINIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG,
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
} from '../../../../../constants/service/app/productConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';
import { PRODUCT_DETAIL_GUIDE_DOWNLOAD_LINK } from '../../../../../constants/service/app/productConstantsV2';
import './ProductDescriptionImg.scss';

const ProductDescriptionImg = (props) => {
  const { isEditable, form, initialValue, isCompare, comparisonData, ...res } = props;
  const { orderExampleMessage, detailImg } = form.getFieldsValue();

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_DESCRIPTION_IMG}
      className="product-detail-description-img"
      title="상품 상세 설명"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        {/*상품 상세 이미지*/}
        <ImgUploadForm
          form={form}
          name="detailImg"
          className="product-detail-img"
          label={
            <span>
              상품 상세 (이미지 첨부)
              <CountOfTotal content={detailImg} maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG} />
            </span>
          }
          initialValue={initialValue.detailImg}
          canAddVideo={true}
          modalTitle="상품 상세 이미지"
          maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG}
          minCnt={MINIMUM_NUMBER_OF_PRODUCT_DETAIL_IMG}
          multiple
          isEditable={isEditable}
          cropMode={false}
          isProductAttachment={true}
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          subContent={
            <div className="sub-info">
              <div>*권장 가로 크기: 1125px 이상 (권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
              <div>*권장 세로 크기: 3000-5000px 이하 (권장 크기를 초과할 경우 로드 속도를 저하시킬 수 있습니다.)</div>
              <div>*파일 크기 20MB 이하</div>
              <div>*추가 상품상세설명 이미지는 최대 20장까지 저장할 수 있습니다.</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
              <div>*상품명과 직접적 관련 없는 상품상세, 외부 링크 입력 시 관리자에 의해 판매 금지될 수 있습니다.</div>
              <div>*안전거래정책에 위배될 경우 관리자에 의해 제재조치가 있을 수 있습니다.</div>
              <Anchor
                isUnderLine
                href={PRODUCT_DETAIL_GUIDE_DOWNLOAD_LINK}
                target="_blank"
                text="상세페이지 제작 가이드 PSD 다운로드(클릭)"
              />
            </div>
          }
        />

        {/* 주문 예시 메시지*/}
        <InputForm
          label={
            <span>
              주문 메시지
              <CountOfTotal content={orderExampleMessage} maxCnt={MAXIMUM_NUMBER_OF_ORDER_EXAMPLE_MESSAGE} />
            </span>
          }
          className={isCompare && compareProductVersion(orderExampleMessage, comparisonData.orderExampleMessage)}
          form={form}
          isEditable={isEditable}
          initialValue={initialValue.orderExampleMessage}
          maxLength={MAXIMUM_NUMBER_OF_ORDER_EXAMPLE_MESSAGE}
          name="orderExampleMessage"
          subContent={
            <div className="sub-info">
              <div>*상품 주문 시, 요청사항을 적는 부분입니다.</div>
              <div>ex)"추가 요청사항 혹은 각인 문구를 기재해 주세요."</div>
              <div>*해당 내용을 입력했을 때만, 주문 메시지를 입력할 수 있습니다.</div>
            </div>
          }
        />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductDescriptionImg;
